export default __webpack_public_path__ + "static/media/lower-case.d7df4ccc.svg";